import React, { useEffect } from "react";
import HeroSection from "./HeroSection";
import Mission from "./Mission";
import ImpactStats from "./ImpactStats";
import OurWork from "./OurWork";
import LatestProject from "./LatestProject";
import Stories from "./Stories";
import RecentActivities from "./RecentActivities";
import CallToAction from "./CallToAction";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Home.css";

const Home = () => {
  useEffect(() => {
    AOS.init({ 
      duration: 1200,
      once: true,
      easing: 'ease-out-cubic'
    });
  }, []);

  return (
    <div>
      <HeroSection />
      <ImpactStats />
      <hr />
      <Mission />
      <hr />
      <OurWork />
      <hr />
      <LatestProject />
      <hr />
      <Stories />
      <hr />
      <RecentActivities />
      <CallToAction />
    </div>
  );
};

export default Home;
